<template>
    <footer class="bg-gray-100" aria-labelledby="footer-heading">
        <div class="px-4 py-12 mx-auto max-w-7xl sm:px-6 lg:py-16 lg:px-8">
            <div class="md:grid md:grid-cols-2 md:gap-8">
                <div class="flex flex-col items-center space-y-8 md:col-span-1 md:items-start">
                    <img class="h-8"
                         src="https://drupal-space.nyc3.cdn.digitaloceanspaces.com/s3fs-public/vm-logorgb_horz-525-2300-c_163x40.png"
                         alt="Valley Metro">
                    <div class="my-8">
                        <div class="flex-1 mt-2">
                            <h2 class="text-lg font-normal leading-normal text-gray-800">Contact Us</h2>
                        </div><br>
                        <a href="mailto:csr@valleymetro.org" class="link link--button">
                            Email Us
                            <Icon class="w-4 h-4 ml-2 text-white" :icon="mdiChevronRight" aria-hidden="true" />
                        </a>
                        <p class="mt-2 text-base font-normal tracking-wide text-gray-600">
	                        <a href="tel:16022535000" title="Call Valley Metro customer service at (602) 253-5000">
                                <strong>(602) 253-5000</strong>
                            </a>
                            <strong> or </strong>
                            <a href="tel:711" aria-label="AZ Relay 711">
                                <strong>AZ Relay 711</strong>
                            </a>
                        </p>
                    </div>

                    <ul class="flex space-x-6 list-none">
                        <li class="flex">
                            <a href="https://www.facebook.com/valleymetro" title="follow Valley Metro on Facebook" target="_blank" class="text-gray-600 hover:text-gray-700">
                                <span class="sr-only">Facebook</span>
                                <Icon class="w-6 h-6" :icon="mdiFacebook" aria-hidden="true" aria-label="Facebook icon"/>
                            </a>
                        </li>
                        <li class="flex">
                            <a href="https://x.com/valleymetro" title="Follow Valley Metro on X" target="_blank" class="text-gray-600 hover:text-gray-700">
                                <span class="sr-only">X</span>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="w-6 h-6" aria-hidden="true" aria-label="Twitter icon">
                                    <path fill="currentColor" d="M13.68 10.62 20.24 3h-1.55L13 9.62 8.45 3H3.19l6.88 10.01L3.19 21h1.55l6.01-6.99 4.8 6.99h5.24l-7.13-10.38Zm-2.13 2.47-.7-1-5.54-7.93H7.7l4.47 6.4.7 1 5.82 8.32H16.3z"></path>
                                </svg>
                            </a>
                        </li>
                        <li class="flex">
                            <a href="https://www.instagram.com/valleymetro/" title="Follow Valley Metro on instagram" target="_blank" class="text-gray-600 hover:text-gray-700">
                                <span class="sr-only">Instagram</span>
                                <Icon class="w-6 h-6" :icon="mdiInstagram" aria-hidden="true" />
                            </a>
                        </li>
                        <li class="flex">
                            <a href="https://www.tiktok.com/@ridevalleymetro" title="Follow Valley Metro on TikTok" target="_blank" class="text-gray-600 hover:text-gray-700">
                                <span class="sr-only">TikTok</span>
                                <svg data-v-748ddf3a="" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" class="w-6 h-6" aria-hidden="true" style="--748ddf3a-hoverColor: initial; --748ddf3a-focusColor: initial;">
                                    <path data-v-748ddf3a="" class="custom-icon-path" fill="currentColor" d="M12.53.02C13.84 0 15.14.01 16.44 0c.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"></path>
                                </svg>
                            </a>
                        </li>
                        <li class="flex">
                            <a href="https://www.youtube.com/ValleyMetro" title="Follow Valley Metro on YouTube"  target="_blank" class="text-gray-600 hover:text-gray-700">
                                <span class="sr-only">YouTube</span>
                                <Icon class="w-6 h-6" :icon="mdiYoutube" aria-hidden="true" />
                            </a>
                        </li>
                        <li class="flex">
                            <a href="/webforms/valley_metro_email_notices" title="Sign up for Valley Metro email notices" target="_blank" class="text-gray-600 hover:text-gray-700">
                                <span class="sr-only">Valley Metro email notices</span>
                                <Icon class="w-6 h-6" :icon="mdiMail" aria-hidden="true" />
                            </a>
                        </li>
                        <li class="flex">
                            <a href="https://www.flickr.com/photos/valleymetro/albums" title="Follow Valley Metro on flicker" target="_blank" class="text-gray-600 hover:text-gray-700">
                                <span class="sr-only">Flicker</span>
                                <Icon class="w-6 h-6" :icon="mdiCameraBurst" aria-hidden="true" />
                            </a>
                        </li>
                    </ul>
                </div>
                <div class="grid grid-cols-2 gap-8 mt-12 md:mt-0 md:col-span-1">
                    <div>
                        <ul class="space-y-4">
                            <li>
                                <a href="/" class="text-base text-gray-600 hover:text-gray-900">
                                    Home
                                </a>
                            </li>

                            <li>
                                <a href="/trip-planner" class="text-base text-gray-600 hover:text-gray-900">
                                    Trip Planner
                                </a>
                            </li>

                            <li>
                                <a href="/maps-schedules" class="text-base text-gray-600 hover:text-gray-900">
                                    Maps & Schedules
                                </a>
                            </li>

                            <li>
                                <a href="/fares" class="text-base text-gray-600 hover:text-gray-900">
                                    Fares
                                </a>
                            </li>

                            <li>
                                <a href="/rider-alerts" class="text-base text-gray-600 hover:text-gray-900">
                                    Rider Alerts
                                </a>
                            </li>

                            <li>
                                <a href="/how-to-ride" class="text-base text-gray-600 hover:text-gray-900">
                                    How to Ride
                                </a>
                            </li>

                            <li>
                                <a href="/news-events" class="text-base text-gray-600 hover:text-gray-900">
                                    News & Events
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div>
                        <ul role="list" class="space-y-4">
                            <li>
                                <a href="/about" class="text-base text-gray-600 hover:text-gray-900">
                                    About Valley Metro
                                </a>
                            </li>

                            <li>
                                <a href="/contact" class="text-base text-gray-600 hover:text-gray-900">
                                    Contact Us
                                </a>
                            </li>

                            <li>
                                <a href="/careers" class="text-base text-gray-600 hover:text-gray-900">
                                    Careers
                                </a>
                            </li>

                            <li>
                                <a href="/transit-education" class="text-base text-gray-600 hover:text-gray-900">
                                    Transit Education
                                </a>
                            </li>

                            <li>
                                <a href="/commute-solutions" class="text-base text-gray-600 hover:text-gray-900">
                                    Commute Solutions
                                </a>
                            </li>

                            <li>
                                <a href="/accessibility" class="text-base text-gray-600 hover:text-gray-900">
                                    Accessibility
                                </a>
                            </li>
                            <li>
                                <a href="/accessibility/ada-paratransit" class="text-base text-gray-600 hover:text-gray-900">
                                    Paratransit &amp; RideChoice Reservations
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="mt-12 space-y-4 text-sm text-gray-600">
                <h3 class="text-base font-bold">Civil Rights Protections</h3>

                <p>Valley Metro is committed to operating its programs and services without regard to disability, race,
                    color or national origin, and encourage diversity on our committees and advisory boards, in
                    accordance with applicable federal statutes:</p>
                <p>Title II of the Americans with Disabilities Act | <a class="link"
                                                                        href="/accessibility/ada-policy-statement">ADA&nbsp;Public
                    Notice/Policy Statement </a> | <a class="link" href="/webforms/ada_complaint">ADA Complaint
                    Process</a></p>
                <p>Title VI of the Civil Rights Act | <a class="link" href="/about/civil-rights"
                                                         rel="noopener noreferrer">Title VI Public
                    Notice/Policy Statement</a> | <a class="link" href="/webforms/title_vi_complaint">Title VI
                    Complaint Process</a></p>
            </div>
            <div class="pt-8 mt-12 border-t border-gray-200">
                <div class="mt-8 text-sm text-gray-600 xl:text-center">
                    &copy; Copyright {{ year }} Valley Metro. All Rights Reserved. | <a href="/privacy-notice" class="link">Privacy Notice</a>
                </div>
            </div>
        </div>

        <ChatBotWidget
            v-if="isChatBotEnabled && chatBotAgencyCode && isChatbotMountable"
            :agency-code="chatBotAgencyCode"
        />
    </footer>
</template>

<script>
import {mdiChevronRight, mdiFacebook, mdiInstagram, mdiTwitter, mdiYoutube, mdiMail, mdiCameraBurst} from '@mdi/js';
import {computed, ref, onUnmounted} from "vue";
import {usePage, router} from "@inertiajs/vue3";
import ChatBotWidget from "../components/ChatBotWidget.vue";
import Icon from "./Icon";

export default {
    name: "SiteFooter",
    components: { Icon, ChatBotWidget },

    setup() {
        const page = usePage();
        const featureFlags = page.props.global.feature_flags || {};

        const aiChatBotMountedPages = featureFlags.ai_chatbot_mounted_pages ? featureFlags.ai_chatbot_mounted_pages.split(/\r?\n/).map(url => url.trim()).filter(Boolean) : [];
        const aiChatBotRestrictedPages = featureFlags.ai_chatbot_restricted_pages ? featureFlags.ai_chatbot_restricted_pages.split(/\r?\n/).map(url => url.trim()).filter(Boolean) : [];

        const isChatBotEnabled = computed(() => {
            return featureFlags.chat_bot_enabled || false;
        });

        const chatBotAgencyCode = computed(() => {
            return featureFlags.chat_bot_agency || '';
        });

        const matchesUrl = (currentUrl, patterns) => {
            let urlMatch = false;

            patterns.forEach(function(value, key) {

                // Ignore empty entries and remove whitespace.
                value = value.trim();
                if (!value) return;

                // Address user inputted www.example.com instead of https://www.example.com.
                if (value.startsWith('www')) {
                    value = `https://${value}`;
                }

                // If this turns out to be an absolute URL, return just the path.
                // https://www.example.com/sample?foo=bar -> /sample
                try {
                    value = new URL(value).pathname;
                } catch {
                    // Not an absolute URL; keep the original value.
                }

                // Ensure relative paths start with a slash.
                // maps-schedules/2 -> /maps-schedules/2
                if (!value.startsWith('/')) {
                    value = `/${value}`;
                }

                // Check to see if current URL matches the list entry exactly,
                // or if the website-wide wildcard exists.
                if (value === currentUrl || value === '/*') {
                    urlMatch = true;
                }
                else if (value.endsWith('*') && !urlMatch) {
                    // Map wildcard links, such as /news/*.
                    let trackProgress = true;
                    let valueParts = value.split('/');
                    let currentUrlParts = currentUrl.split('/');
                    let splitIndex = 0;

                    while (!urlMatch && splitIndex < valueParts.length && splitIndex < currentUrlParts.length) {
                        let splitVal = valueParts[splitIndex];

                        if (splitVal === '*') {
                            urlMatch = true;
                            break;
                        }

                        if (splitVal !== currentUrlParts[splitIndex]) {
                            trackProgress = false;
                            break;
                        }

                        splitIndex++;
                    }

                    if (trackProgress && splitIndex === valueParts.length) {
                        urlMatch = true;
                    }
                }
            });

            return urlMatch;
        };

        // Reactive state allows chatbot visibility to update during Inertia navigation.
        const isChatbotMountable = ref(false);

        const checkChatbotMountable = () => {
            const currentUrl = window.location.pathname;

            const mountedUrlMatch = matchesUrl(currentUrl, aiChatBotMountedPages);
            const restrictedUrlMatch = matchesUrl(currentUrl, aiChatBotRestrictedPages);

            isChatbotMountable.value = mountedUrlMatch && !restrictedUrlMatch;
        };

        // Check the current page on initial load.
        checkChatbotMountable();

        // Recheck after every successful Inertia navigation.
        const removeNavigationListener = router.on('navigate', () => {
            checkChatbotMountable();
        });

        // Prevent the listener from remaining registered if this component is destroyed.
        onUnmounted(() => {
            removeNavigationListener();
        });

        const useInternalAdaParatransitReservationsHref = !!featureFlags.ada_paratransit_reservations_internal_link;

        const adaParatransitReservationHref = useInternalAdaParatransitReservationsHref
            ? '/accessibility/ada-paratransit/ada-paratransit-reservations'
            : 'https://reservations.valleymetro.org';

        const adaParatransitReservationTarget = useInternalAdaParatransitReservationsHref ? null : '_blank';

        const year = new Date().getFullYear();

        return {
            year,
            adaParatransitReservationHref,
            adaParatransitReservationTarget,
            mdiChevronRight,
            mdiTwitter,
            mdiFacebook,
            mdiInstagram,
            mdiYoutube,
            mdiMail,
            mdiCameraBurst,
            aiChatBotMountedPages,
            aiChatBotRestrictedPages,
            isChatBotEnabled,
            chatBotAgencyCode,
            isChatbotMountable,
        };
    }
};
</script>